











import Component from 'vue-class-component';

import UiPageHeader from '@/components/ui/UiPageHeader.vue';

import { BaseVue } from '../../BaseVue';
import Invitees from '../../components/org/Invitees.vue';

@Component({
  components: {
    Invitees,
    UiPageHeader,
  },
})
export default class InviteesClass extends BaseVue {
  public selectedTab = 0;
}
